import React from "react";

/* ============================================================================
 * HomeAbout — จุดเด่นบริการ + แถบตัวเลขความน่าเชื่อถือ
 *
 * วางเป็น 2 คอลัมน์ : เหตุผลที่ควรเลือกเรา (ซ้าย) คู่กับตัวเลขที่พิสูจน์เหตุผล
 * นั้น (ขวา) — อ่านจบในสายตาเดียว ไม่ต้องเลื่อนลงไปหาตัวเลขอีกชั้น
 *
 * เนื้อหาทั้งหมดแก้ไขได้จากหลังบ้าน (/ad/home/features) จึงอ่านเป็นข้อความตรง ๆ
 * ไม่ผ่าน t() — API ส่งมาเฉพาะรายการที่เปิดใช้งาน เรียงตามลำดับที่ตั้งไว้แล้ว
 * ========================================================================== */
export default function HomeAbout({ data }) {
  const items = data?.items || [];
  const stats = data?.stats || [];

  return (
    <section className="hm-section" id="hm-about">
      <div className="hm-container">
        <div className="hm-section__head hm-section__head--tight">
          <h2 className="hm-section__title hm-section__title--sm">{data?.section?.title || ""}</h2>
        </div>

        <div className="hm-about">
          <div className="hm-features">
            {items.map((item) => (
              <div className="hm-feature" key={item.uid}>
                <div className="hm-feature__icon hm-ico">{item.icon}</div>
                <div className="hm-feature__title">{item.title}</div>
                <p className="hm-feature__desc">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="hm-stats">
            {stats.map((item) => (
              <div className="hm-stat" key={item.uid}>
                <div className="hm-stat__value">{item.value}</div>
                <div className="hm-stat__label">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
